module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifDemi.b74cae4d.woff";